"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var updateConversationsCategoriesService_1 = require("../../../services/updateConversationsCategoriesService");
var owa_analytics_1 = require("owa-analytics");
var conversationsCategoriesStoreUpdate_1 = require("owa-mail-actions/lib/triage/conversationsCategoriesStoreUpdate");
var undoActions = require("owa-mail-undo");
var owa_service_error_1 = require("owa-service-error");
var owa_mail_strings_1 = require("owa-strings/owa-mail-strings");
var owa_mail_list_store_1 = require("owa-mail-list-store");
/**
 * Categorize the conversations from table
 * @param conversationRowKeys to be categorized
 * @param tableView that contain the conversations
 * @param categorizesToAdd the categories to add to the conversations
 * @param categorizesToRemove the categories to be removed from the conversations
 * @param clearCategories a boolean which indicates whether to clear categories for the specified conversations
 * @param actionSource where the action is triggered from
 */
function updateConversationsCategoriesInternal(conversationRowKeys, tableView, categoriesToAdd, categoriesToRemove, clearCategories, actionSource) {
    validateCategoryParameters(conversationRowKeys, categoriesToAdd, categoriesToRemove, clearCategories);
    undoActions.clearLastUndoableAction();
    // VSO 23862 - Instrumentation for category triage actions
    owa_service_error_1.handleServiceError('updateConversationsCategoriesInternal', owa_mail_strings_1.default.errorUpdatingCategories, function () {
        var contextFolderId = owa_mail_list_store_1.getContextFolderIdForTable(tableView);
        var conversationActionContexts = conversationRowKeys.map(function (rowKey) {
            return owa_mail_list_store_1.getApplyConversationActionContext(rowKey, tableView.id);
        });
        var datapoint = owa_analytics_1.returnTopExecutingActionDatapoint();
        var promiseToReturn = updateConversationsCategoriesService_1.default(conversationActionContexts, contextFolderId, categoriesToAdd, categoriesToRemove, clearCategories).catch(function (e) {
            datapoint.endWithError(owa_analytics_1.DatapointStatus.ServerError);
        });
        // Update the conversation categories in store
        conversationsCategoriesStoreUpdate_1.default(conversationRowKeys, tableView.id, categoriesToAdd, categoriesToRemove, clearCategories);
        return promiseToReturn;
    });
}
exports.default = updateConversationsCategoriesInternal;
/**
 * Validate the update categories parameters
 * @param categoriesToAdd the categories to be added to the conversations
 * @param categoriesToRemove the categories to be removed from the conversations
 * @param clearCategories whether to clear categories
 */
function validateCategoryParameters(conversationRowKeys, categoriesToAdd, categoriesToRemove, clearCategories) {
    if (!conversationRowKeys || conversationRowKeys.length === 0) {
        throw new Error('Update category action should not be exposed.');
    }
    if (clearCategories && (!!categoriesToAdd || !!categoriesToRemove)) {
        throw new Error('When clearCategories is true, categoriesToAdd and categoriesToRemove both have to be null.');
    }
    if (!!categoriesToAdd && !!categoriesToRemove) {
        throw new Error('Can only add or remove categories at one time.');
    }
}
//# sourceMappingURL=updateConversationsCategoriesInternal.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-triage-action/lib/actions/categories/helpers/updateConversationsCategoriesInternal.js
// module id = 5667
// module chunks = 62